import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PetInsuranceDetailStateService {
  private _petInsuranceUid = signal<string | undefined>(undefined);

  petInsuranceUid = this._petInsuranceUid.asReadonly();

  open(uid: string) {
    this._petInsuranceUid.set(uid);
  }

  close() {
    this._petInsuranceUid.set(undefined);
  }
}
